
// import React from 'react';
// import ReactDOM from 'react-dom';
 
// function showTime()
// {
// const myElement = (
//                    <div>
//                         <h1>Welcome to GeeksforGeeks!</h1>
//                         <h2>{new Date().toLocaleTimeString()}</h2>
//                    </div>
//                   );
 
// ReactDOM.render(
//       myElement,
//       document.getElementById("root")
// );                   
// }
 
// setInterval(showTime, 1000);


// import React from 'react';
// import ReactDOM from 'react-dom';
 
// // Example Component
// function Example(props)
// {
//     if(!props.toDisplay)
//         return null;
//     else
//         return <h1>Component is rendered</h1>;
// }
 
// ReactDOM.render(
//     <div>
//         <Example toDisplay = {false} />
//         <Example toDisplay = {true} />
//     </div>,
//     document.getElementById('root')
// );


// import React from 'react'; 
// import ReactDOM from 'react-dom'; 
  
// // This is a functional component 
// const Welcome=()=>
// { 
//         return <h1>Hello World!</h1> 
// } 
  
// ReactDOM.render( 
//     <Welcome />, 
//     document.getElementById("root") 
// ); 

// import React from 'react';
// import ReactDOM from 'react-dom';
 
// // Input field component
// const Input=()=>
// {
//     return(
//         <div>
//             <input type="text" placeholder="Enter Text.." />
//             <br />
//             <br />   
//         </div>
//     );
// }
 
// // Button Component
// const Button=()=>
// {
//     return <button type = "submit">Submit</button>;   
// }
 
// // Form component
// const Form=()=>
// {
//     return (
//         <div>
//             <Input />
//             <Input />
//             <Input />
//             <Button />           
//         </div>
//     );
// }
 
// ReactDOM.render(
//     <Form />,
//     document.getElementById("root")
// );

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
 
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
